import React, { useRef, useEffect } from 'react';

interface Props {
  value: string;
  onChange: (v: string) => void;
  onSend: () => void;
  onOpenMobileFilter: () => void;
  isStreaming: boolean;
  capExceeded: boolean;
  capMessage?: string;
}

export const ChatInput: React.FC<Props> = ({
  value,
  onChange,
  onSend,
  onOpenMobileFilter,
  isStreaming,
  capExceeded,
  capMessage,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (!isStreaming) textareaRef.current?.focus({ preventScroll: true });
  }, [isStreaming]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!isStreaming && !capExceeded) onSend();
    }
  };

  return (
    <div className="ai-input-area">
      {capExceeded && capMessage && (
        <div className="ai-cap-banner">{capMessage}</div>
      )}
      <div className="ai-chat-toolbar">
        <button className="ai-btn-toolbar ai-btn-filter" onClick={onOpenMobileFilter} title="Filter documents">
          ☰ Filter docs
        </button>
      </div>
      <div className="ai-chat-input-row">
        <textarea
          ref={textareaRef}
          className="ai-chat-textarea"
          placeholder={capExceeded ? 'Query limit reached' : 'Ask a question…'}
          value={value}
          onChange={e => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isStreaming || capExceeded}
          rows={2}
        />
        <button
          className="ai-btn-send"
          onClick={onSend}
          disabled={isStreaming || capExceeded || !value.trim()}
          title="Send"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z" fill="white" />
          </svg>
        </button>
      </div>
      <p className="ai-chat-footer">
        AI uses selected documents and may contain errors.
      </p>
    </div>
  );
};
